// app/providers/OidcAuthProvider.jsx
"use client";

import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_4edaAl6xY",
  client_id: "1i57shm772i0g5k9bi280dbt5q",
  redirect_uri: "https://rec-builder.com/profile",
  response_type: "code",
  scope: "email openid phone",
};

export default function OidcAuthProvider({ children }) {
  return <AuthProvider {...cognitoAuthConfig}>{children}</AuthProvider>;
}
